import React from "react";
import { useAppStateContext } from "src/auth/AppStateContext";
import { FaRegEye } from "react-icons/fa";
import APIService from "src/services/Api";
import useQueryListAdminNotification from "src/hooks/useQueryListAdminNotification";

type ParamNavAdmin = {
  handleShowNav:(value:boolean) => void
}


const NavUserAdminNotification: React.FC<ParamNavAdmin> = ({handleShowNav}) => {
  const { notificationAdminList } = useQueryListAdminNotification(0);
  const { adminNotifications } = useAppStateContext();
    const viewNotifications = async() => {
      handleShowNav(true)
      if(adminNotifications.some(n => !n.seen)){
        await APIService.systemViewNotifications({type:'admin'})
      }
    }

  return (
    <div>
      {adminNotifications && adminNotifications.length > 0 && (
        <div className="relative rounded-full px-2 py-1 hover:bg-gray-300 cursor-pointer transition duration-500 ease-in-out transform hover:-translate-y-0  ">
          {adminNotifications.length === 0 && (
            <div>
              <FaRegEye className="text-stone-300" size={30} />
            </div>
          )}

          {adminNotifications.some((n) => n.type === "Alert") ? (
            <div
              onClick={() => viewNotifications()}
              className="rounded-full"
            >
              <span className="notification-quantity border border-gray-100">
                {adminNotifications.filter((n) => !n.seen).length || 1}
              </span>
              <FaRegEye className="text-red-400" size={27} />
            </div>
          ) : (
            <div onClick={() => viewNotifications()}>
              <FaRegEye className="text-stone-700" size={30} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NavUserAdminNotification;
